export default "__VITE_ASSET__ZWn30gSs__"